import {
  Avatar,
  PLATFORM,
  STATUSPAGE,
  PageWrapper,
  UserOnlineInfo,
  MapsUsersOnline,
  getFirstLetter,
} from '@repo/ui';
import { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Card, Col, Row } from 'reactstrap';

import { useUsersOnline } from '../hooks/useUsersOnline';

export const UsersOnline = () => {
  const {
    requestUsersOnline,
    requestUsersOnlineMaps,
    requestUsersOnlineHeaders,
    userOnlineStatus,
    userOnlineMapsStatus,
    listUsersOnline,
    listUsersOnlineMaps,
  } = useUsersOnline();

  const getColorPlatform = (platform: string) => {
    switch (platform) {
      case PLATFORM.WEB_ADMIN:
        return '#144c5b';
      case PLATFORM.WEB_GESTOR:
        return '#ff7f50';

      case PLATFORM.APP_RADE_ESTUDANTE:
        return '#25a871';

      case PLATFORM.APP_RADE_PROFISSIONAL:
        return '#104831';

      default:
        return '#797979';
    }
  };

  useEffect(() => {
    requestUsersOnline();
    requestUsersOnlineMaps();
    requestUsersOnlineHeaders({ limit: '10' });
  }, []);

  return (
    <PageWrapper title="Usuários on-line">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Usuários on-line</h4>
          <p className="text-muted mb-0">
            <span className="fw-bold">{listUsersOnline?.count} </span>
            Usuários on-line no momento
          </p>
        </div>
      </div>
      <Row>
        {userOnlineStatus === STATUSPAGE.LOADING ? (
          <Col md={12} className="mb-4">
            <Card>
              <Skeleton
                count={1}
                style={{ height: 450 }}
                className="m-3"
                containerClassName="d-flex"
                baseColor="#e8e8e8c5"
                highlightColor="#bababa96"
              />
            </Card>
          </Col>
        ) : (
          listUsersOnline?.users?.map((user) => (
            <Col md={6} sm={6} xs={12} lg={6} xl={3} key={user.id}>
              <Card
                style={{
                  borderTop: `7px solid ${getColorPlatform(user.platform)}`,
                }}
                className="p-3"
              >
                <Avatar
                  photo={user.avatar}
                  placeholderText={getFirstLetter(user.name)}
                />
                <UserOnlineInfo user={user} />
              </Card>
            </Col>
          ))
        )}
      </Row>
      <Row>
        <Col md={12}>
          <MapsUsersOnline
            data={listUsersOnlineMaps}
            loadingStatusMaps={userOnlineMapsStatus}
          />
        </Col>
      </Row>
    </PageWrapper>
  );
};
